import SupportListWrapper from 'core/page/SupportListWrapper'
import { listMessages } from '../state/actions'
import N from 'utils-support/navigation'
import { GETMessagesResponseRow } from '@cbgms/api/modules/messages'

export const onAdd = () => N.push('/messages/new')

export const onEdit = (data: GETMessagesResponseRow) => N.push(`/messages/edit/${data.SystemMessage.UUID}`)

export const MessagesList = () => {
  return <SupportListWrapper scope='system-messages' onAdd={onAdd} onEdit={onEdit} loadAction={listMessages} translationKey='messages' />
}

export default MessagesList
